import React from "react";
import "./WhoWeExcellence.css";
import AboutImage from "../../Image/Whoweare/Whoweare.png";

export default function WhoWeExcellence() {
  return (
    <section className="who-excellence-section">
      <div className="who-excellence-container">

        {/* LEFT: IMAGE */}
        <div className="who-excellence-col who-excellence-left">
          <div className="who-excellence-image-wrapper">
            <img
              src={AboutImage}
              alt="Building Excellence"
              className="who-excellence-img"
            />
          </div>
        </div>

        {/* RIGHT: CONTENT */}
        <div className="who-excellence-col who-excellence-right">
          <div className="who-excellence-content">

            {/* <span className="who-excellence-tag">
              Established in 2019
            </span> */}

            <h2 className="who-excellence-title">
              Building Trust Through Excellence
            </h2>

            <p className="who-excellence-text">
               We have built a reputation for professionalism,
              transparent service delivery and strong client relationships. Our
              commitment to quality and compliance has made us a trusted partner
              for businesses across multiple sectors.
            </p>

            <p className="who-excellence-text">
              We combine trained manpower, efficient processes and full statutory
              compliance to help organisations maintain world-class environments
              that enhance productivity and workplace satisfaction.
            </p>

          </div>
        </div>

      </div>
    </section>
  );
}
